package amazon.lastmile.inject

import app.nestbridge.domain.identity.api.ProfessionalProfileApiClient
import app.nestbridge.domain.identity.api.RemoteProfessionalProfileApiClient
import me.tatarka.inject.annotations.Provides
import software.amazon.lastmile.kotlin.inject.anvil.`internal`.Origin

@Origin(value = RemoteProfessionalProfileApiClient::class)
public interface AppNestbridgeDomainIdentityApiRemoteProfessionalProfileApiClient {
  @Provides
  public fun provideRemoteProfessionalProfileApiClientProfessionalProfileApiClient(remoteProfessionalProfileApiClient: RemoteProfessionalProfileApiClient): ProfessionalProfileApiClient = remoteProfessionalProfileApiClient
}
